import React from 'react'
import { LocalStorage } from '../services'
import { UsuarioAPI, AnunciosAPI, AuthAPI } from '../api'
import { AuthContext } from './AuthContext'
import { Alerts } from '../components/Simple'
import RouterHook from './RouterHook'

export const UsuarioContext = React.createContext({
  userUCtx: {
    ultimoPedido: LocalStorage.get('ultimo-pedido') || null,
    usuario: LocalStorage.get('user-loged') || null,
    cidade: LocalStorage.get('cidade-user') || null,
    agendaUsuario: [],
    modalCard: false,
  },
  loadsUCtx: {
    ultimoPedido: false,
    anuncios: true,
    userIsGestor: false,
    deleteUser: false,
    updateUserPass: false,
  },
  actionsUCtx: {
    // eslint-disable-next-line no-unused-vars
    AtualizarUsuario: async usuario => {},
    BuscarUltimoPedido: async () => {},
    // eslint-disable-next-line no-unused-vars
    BuscarAnunciosCidade: async cidade => {},
    VerificarUsuarioIsGestor: async () => {},
    DeleteUser: async () => {},
    // eslint-disable-next-line no-unused-vars
    ChangePassUser: async (senha, newPass) => {},
    // eslint-disable-next-line no-unused-vars
    handleUsuario: usuario => {},
    // eslint-disable-next-line no-unused-vars
    handleUserUCtx: (key, val) => {},
    // eslint-disable-next-line no-unused-vars
    handleCidade: cidade => {},
  },
})

export default function UsuarioContextProvider({ children }) {
  const serverRouter = RouterHook()
  const { actionsAuth, sttAuthCtx } = React.useContext(AuthContext)
  const [userUCtx, setUserUCtx] = React.useState({
    usuario: LocalStorage.get('user-loged') || null,
    cidade: LocalStorage.get('cidade-user') || null,
    agendaUsuario: [],
    ultimoPedido: LocalStorage.get('ultimo-pedido') || null,
  })

  const [loadsUCtx, setLoadsUCtx] = React.useState({
    ultimoPedido: false,
    anuncios: false,
    userIsGestor: false,
    deleteUser: false,
    updateUser: false,
    updateUserPass: false,
  })
  React.useEffect(() => {
    if (sttAuthCtx.isLogged) {
      // Verifica se o usuário tem os dados necessários para continuar
      if (!userUCtx.usuario) {
        actionsAuth.StartLogout()
        serverRouter('login')
      }
    }
  }, [userUCtx.usuario, sttAuthCtx.isLogged])

  const actionsUCtx = {
    AtualizarUsuario: async usuario => {
      let user = JSON.parse(JSON.stringify(usuario))
      if (
        usuario.atleta &&
        usuario.atleta.nascimento &&
        usuario.atleta.nascimento.length === 10 &&
        usuario.atleta.nascimento.includes('-')
      ) {
        const data = usuario.atleta.nascimento.split('-')
        user.atleta.nascimento = `${data[2]}/${data[1]}/${data[0]}`
      }

      const req = await UsuarioAPI.AtualizarUsuario(user)
      if (req.error) {
        return { retorno: false }
      }
      if (req.retorno) {
        // Verifica se data de nascimento esta nesse formato dd/mm/yyyy
        if (
          usuario.atleta.nascimento &&
          usuario.atleta.nascimento.length === 10 &&
          usuario.atleta.nascimento.includes('/')
        ) {
          const data = usuario.atleta.nascimento.split('/')
          user.atleta.nascimento = `${data[2]}-${data[1]}-${data[0]}`
          usuario.atleta.nascimento = `${data[2]}-${data[1]}-${data[0]}`
        }
        setUserUCtx({ ...userUCtx, usuario })
        LocalStorage.set('user-loged', usuario)
      }
      return req
    },
    BuscarUltimoPedido: async () => {
      setLoadsUCtx(loadsUCtx => ({ ...loadsUCtx, ultimoPedido: true }))
      const req = await UsuarioAPI.BuscarUltimoPedido(userUCtx.usuario.idusuario)

      if (req.error) {
        return { retorno: false }
      }
      if (req.length) {
        setUserUCtx(userUCtx => ({ ...userUCtx, ultimoPedido: req[0] }))
      } else {
        setUserUCtx(userUCtx => ({ ...userUCtx, ultimoPedido: null }))
      }
      setLoadsUCtx(loadsUCtx => ({ ...loadsUCtx, ultimoPedido: false }))
      return req
    },
    BuscarAnunciosCidade: async cidade => {
      setLoadsUCtx(loadsUCtx => ({ ...loadsUCtx, anuncios: true }))
      const req = await AnunciosAPI.BuscarAnuncios(cidade.idcidade)

      if (req.error) {
        return req
      }
      if (req.length) {
        const array = req.map(item => {
          return {
            ...item,
            imgPath: item.foto,
            label: item.titulo,
          }
        })
        setUserUCtx(userUCtx => ({ ...userUCtx, anuncios: array }))
        return array
      } else {
        setLoadsUCtx(loadsUCtx => ({ ...loadsUCtx, anuncios: false }))
        return []
      }
    },
    VerificarUsuarioIsGestor: async () => {
      setLoadsUCtx(loadsUCtx => ({ ...loadsUCtx, userIsGestor: true }))
      const req = await UsuarioAPI.VerificarUsuarioIsGestor(userUCtx.usuario.idusuario)

      if (req.error) {
        return { retorno: false }
      }
      setLoadsUCtx(loadsUCtx => ({ ...loadsUCtx, userIsGestor: false }))
      return req
    },
    DeleteUser: async () => {
      setLoadsUCtx(loadsUCtx => ({ ...loadsUCtx, deleteUser: true }))
      const data = {
        idusuario: userUCtx.usuario.idusuario,
        nome: 'USUARIO_EXCLUIDO',
        username: 'USUARIO_EXCLUIDO',
        usuario: 'USUARIO_EXCLUIDO',
        senha: 'USUARIO_EXCLUIDO',
        atleta_idatleta: userUCtx.usuario.atleta_idatleta,
        atleta: {
          idatleta: userUCtx.usuario.atleta_idatleta,
          nome: 'USUARIO_EXCLUIDO',
          telefone: 'USUARIO_EXCLUIDO',
          email: 'USUARIO_EXCLUIDO',
          sexo: 'USUARIO_EXCLUIDO',
          nascimento: null,
        },
      }
      const req = await UsuarioAPI.AtualizarUsuario(data)
      if (req.error) {
        Alerts.swal(
          'warning',
          'Erro ao excluir dados',
          `Não foi possível excluir seus dados, ${req.detalhes}`,
        )
        return { retorno: false }
      }
      if (req.retorno) {
        Alerts.swal('success', 'Dados excluídos', 'Seus dados foram excluídos com sucesso.')
        actionsAuth.StartLogout()
        serverRouter('login')
      }
    },
    ChangePassUser: async (senha, newPass) => {
      setLoadsUCtx(loadsUCtx => ({ ...loadsUCtx, updateUserPass: true }))
      // Verifica se é a senha.
      const validPass = await AuthAPI.verificar_credenciais(userUCtx.usuario.idusuario, senha)
      if (validPass.error) {
        Alerts.swal(
          'warning',
          'Senha incorreta',
          'A senha atual está incorreta, por favor, verifique e tente novamente.',
        )
        setLoadsUCtx(loadsUCtx => ({ ...loadsUCtx, updateUserPass: false }))
        return { retorno: false }
      }
      if (validPass === true) {
        // Atualiza senha do usuario...
        const user = { ...userUCtx.usuario, senha: newPass }
        //console.log('user', user)
        let flag = false
        if (user.atleta && user.atleta.nascimento)
          if (user.atleta.nascimento.length === 10 && user.atleta.nascimento.includes('-')) {
            const data = user.atleta.nascimento.split('-')
            user.atleta.nascimento = `${data[2]}/${data[1]}/${data[0]}`
            flag = true
          }
        const req = await UsuarioAPI.AtualizarUsuario(user)
        //console.log('req', req)
        if (req.error) {
          Alerts.swal(
            'warning',
            'Erro ao alterar senha',
            'Não foi possível alterar sua senha, por favor, tente novamente.',
          )
          setLoadsUCtx(loadsUCtx => ({ ...loadsUCtx, updateUserPass: false }))
          return { retorno: false }
        }
        if (req.retorno) {
          Alerts.swal('success', 'Senha alterada', 'Sua senha foi alterada com sucesso.')
          // exclui senha do usuario
          delete user.senha
          // retorna data para yyyy-mm-dd
          if (flag) {
            const data = user.atleta.nascimento.split('/')
            user.atleta.nascimento = `${data[2]}-${data[1]}-${data[0]}`
          }
          setUserUCtx({ ...userUCtx, usuario: user })
          setLoadsUCtx(loadsUCtx => ({ ...loadsUCtx, updateUserPass: false }))
          LocalStorage.set('user-loged', user)
          return req
        }
      } else {
        Alerts.swal(
          'warning',
          'Erro ao alterar senha',
          'Não foi possível alterar sua senha, por favor, verifique sua senha e tente novamente.',
        )
        setLoadsUCtx(loadsUCtx => ({ ...loadsUCtx, updateUserPass: false }))
        return { retorno: false }
      }
    },
    handleUsuario: usuario => {
      // Verifica se o usuario tem o atributo senha e remove, mesmo que seja null, deve remover o senha
      if (usuario.senha || usuario.senha === null) {
        delete usuario.senha
      }
      LocalStorage.set('user-loged', usuario)
      LocalStorage.set('user-id', usuario.idusuario)
      setUserUCtx({ ...userUCtx, usuario })
    },
    handleUserUCtx: (key, val) => {
      setUserUCtx({ ...userUCtx, [key]: val })
    },
    handleCidade: cidade => {
      setUserUCtx(userUCtx => ({ ...userUCtx, cidade }))
      LocalStorage.set('cidade-user', cidade)
    },
  }

  return (
    <UsuarioContext.Provider
      value={{
        userUCtx,
        loadsUCtx,
        actionsUCtx,
      }}
    >
      {children}
    </UsuarioContext.Provider>
  )
}
